import Slider, { Settings } from 'react-slick';
import './slick.css';
import { forwardRef } from 'react';

interface ICustomSliderProps extends Settings {
  children: React.ReactNode;
  nextArrow?: JSX.Element;
  prevArrow?: JSX.Element;
}

export const CustomSlider = forwardRef<Slider, ICustomSliderProps>(({ children, ...rest }, ref) => {
  return (
    <Slider {...rest} ref={ref}>
      {children}
    </Slider>
  );
});

CustomSlider.displayName = 'CustomSlider';
